import { createTheme } from '@mui/material/styles';

// dark theme - Modern Blue Gradient Theme
const theme = createTheme({
	palette: {
		mode: 'dark',
		primary: {
			main: '#5b7ab8',
			light: '#7a96c8',
			dark: '#3c5a98',
			contrastText: '#0f172a'
		},
		secondary: {
			main: '#4a6a9e',
			light: '#6a8ab8',
			dark: '#2d4578',
			contrastText: '#0f172a'
		},
		background: {
			default: '#0f172a',
			paper: '#1e293b',
			topheaderbg: 'linear-gradient(135deg, #4a6a9e 0%, #3c5a98 100%)',
			menubg: '#1e293b',
			menuhoverbg: '#334155',
			bluebg: 'linear-gradient(135deg, #5b7ab8 0%, #3c5a98 100%)',
			bg: '#0f172a',
			subtle: '#1e293b',
			gradient: 'linear-gradient(135deg, #4a6a9e 0%, #3c5a98 100%)'
		},
		text: {
			primary: '#f1f5f9',
			secondary: '#94a3b8',
			black: '#000000',
			topheadertext: '#f1f5f9',
			menutext: '#94a3b8',
			menuhovertxt: '#f1f5f9',
			kpititle: '#e2e8f0',
			link: '#5b7ab8'
		},
		divider: '#334155',
		action: {
			hover: 'rgba(91, 122, 184, 0.12)',
			selected: 'rgba(91, 122, 184, 0.16)',
			focus: 'rgba(91, 122, 184, 0.12)'
		},
		success: {
			main: '#34d399',
			light: '#6ee7b7',
			dark: '#10b981'
		},
		warning: {
			main: '#fbbf24',
			light: '#fcd34d',
			dark: '#f59e0b'
		},
		error: {
			main: '#f87171',
			light: '#fca5a5',
			dark: '#ef4444'
		},
		info: {
			main: '#60a5fa',
			light: '#93c5fd',
			dark: '#3b82f6'
		}
	},
	typography: {
		fontFamily: '"Inter", "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
		h1: {
			fontFamily: '"Poppins", "Inter", sans-serif',
			fontWeight: 600,
			letterSpacing: '-0.025em'
		},
		h2: {
			fontFamily: '"Poppins", "Inter", sans-serif',
			fontWeight: 600,
			letterSpacing: '-0.025em'
		},
		h3: {
			fontFamily: '"Poppins", "Inter", sans-serif',
			fontWeight: 600,
			letterSpacing: '-0.02em'
		},
		h4: {
			fontFamily: '"Poppins", "Inter", sans-serif',
			fontWeight: 600,
			letterSpacing: '-0.02em'
		},
		h5: {
			fontFamily: '"Poppins", "Inter", sans-serif',
			fontWeight: 600
		},
		h6: {
			fontFamily: '"Poppins", "Inter", sans-serif',
			fontWeight: 600
		},
		subtitle1: {
			fontWeight: 500,
			letterSpacing: '-0.01em'
		},
		subtitle2: {
			fontWeight: 500,
			letterSpacing: '-0.01em'
		},
		body1: {
			letterSpacing: '-0.01em',
			lineHeight: 1.6
		},
		body2: {
			letterSpacing: '-0.01em',
			lineHeight: 1.5
		},
		button: {
			fontWeight: 500,
			letterSpacing: '0.01em',
			textTransform: 'none'
		}
	},
	shape: {
		borderRadius: 10
	},
	shadows: [
		'none',
		'0 1px 2px 0 rgba(0, 0, 0, 0.3)',
		'0 1px 3px 0 rgba(0, 0, 0, 0.4), 0 1px 2px -1px rgba(0, 0, 0, 0.4)',
		'0 4px 6px -1px rgba(0, 0, 0, 0.4), 0 2px 4px -2px rgba(0, 0, 0, 0.4)',
		'0 10px 15px -3px rgba(0, 0, 0, 0.4), 0 4px 6px -4px rgba(0, 0, 0, 0.4)',
		'0 20px 25px -5px rgba(0, 0, 0, 0.5), 0 8px 10px -6px rgba(0, 0, 0, 0.5)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.6)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.6)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.6)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.6)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.6)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.6)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.6)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.6)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.6)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.6)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.6)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.6)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.6)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.6)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.6)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.6)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.6)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.6)',
		'0 25px 50px -12px rgba(0, 0, 0, 0.6)'
	],
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					borderRadius: 10,
					padding: '8px 20px',
					fontWeight: 500,
					boxShadow: 'none',
					transition: 'all 0.2s ease-in-out',
					'&:hover': {
						boxShadow: '0 4px 12px rgba(91, 122, 184, 0.3)',
						transform: 'translateY(-1px)'
					},
					'&:active': {
						transform: 'translateY(0)'
					}
				},
				contained: {
					background: 'linear-gradient(135deg, #5b7ab8 0%, #3c5a98 100%)',
					'&:hover': {
						background: 'linear-gradient(135deg, #4a6a9e 0%, #2d4578 100%)',
						boxShadow: '0 4px 12px rgba(91, 122, 184, 0.4)'
					}
				},
				outlined: {
					borderWidth: '1.5px',
					borderColor: '#5b7ab8',
					'&:hover': {
						borderWidth: '1.5px',
						backgroundColor: 'rgba(91, 122, 184, 0.08)'
					}
				}
			}
		},
		MuiCard: {
			styleOverrides: {
				root: {
					borderRadius: 12,
					boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.4), 0 2px 4px -2px rgba(0, 0, 0, 0.4)',
					border: '1px solid #334155',
					backgroundColor: '#1e293b',
					transition: 'all 0.2s ease-in-out',
					'&:hover': {
						boxShadow: '0 10px 15px -3px rgba(91, 122, 184, 0.15), 0 4px 6px -4px rgba(91, 122, 184, 0.15)',
						borderColor: '#5b7ab8'
					}
				}
			}
		},
		MuiPaper: {
			styleOverrides: {
				root: {
					backgroundImage: 'none',
					backgroundColor: '#1e293b'
				},
				elevation1: {
					boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.4), 0 1px 2px -1px rgba(0, 0, 0, 0.4)'
				},
				elevation2: {
					boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.4), 0 2px 4px -2px rgba(0, 0, 0, 0.4)'
				},
				elevation3: {
					boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.5), 0 4px 6px -4px rgba(0, 0, 0, 0.5)'
				}
			}
		},
		MuiTextField: {
			styleOverrides: {
				root: {
					'& .MuiOutlinedInput-root': {
						borderRadius: 10,
						transition: 'all 0.2s ease-in-out',
						'& .MuiOutlinedInput-notchedOutline': {
							borderColor: '#475569'
						},
						'&:hover .MuiOutlinedInput-notchedOutline': {
							borderColor: '#5b7ab8'
						},
						'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
							borderWidth: '2px',
							borderColor: '#5b7ab8'
						}
					}
				}
			}
		},
		MuiDialog: {
			styleOverrides: {
				paper: {
					borderRadius: 12,
					boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.7)',
					backgroundColor: '#1e293b',
					border: '1px solid #334155'
				}
			}
		},
		MuiTooltip: {
			styleOverrides: {
				tooltip: {
					backgroundColor: '#334155',
					borderRadius: 8,
					fontSize: '0.75rem',
					padding: '6px 12px',
					border: '1px solid #475569'
				}
			}
		},
		MuiChip: {
			styleOverrides: {
				root: {
					borderRadius: 8,
					fontWeight: 500
				}
			}
		},
		MuiTableCell: {
			styleOverrides: {
				head: {
					fontWeight: 600,
					backgroundColor: '#1e293b',
					color: '#e2e8f0',
					borderBottom: '1px solid #334155'
				},
				body: {
					borderBottom: '1px solid #334155'
				}
			}
		},
		MuiTableRow: {
			styleOverrides: {
				root: {
					transition: 'background-color 0.15s ease-in-out',
					'&:hover': {
						backgroundColor: '#334155'
					}
				}
			}
		},
		MuiDivider: {
			styleOverrides: {
				root: {
					borderColor: '#334155'
				}
			}
		},
		MuiContainer: {
			styleOverrides: {
				root: {
					padding: 0,
					paddingLeft: '0 !important',
					paddingRight: '0 !important',
					maxWidth: 'none !important'
				}
			}
		}
	}
});

export default theme;